import { Pipe, PipeTransform } from '@angular/core';
import { LanguageService } from '@meddatacore/common';

@Pipe({
  name: 'lanSuffix',
})
export class LanguageSuffixPipe implements PipeTransform {
  constructor(private language: LanguageService) {}
  transform(value: any, ...args: any[]): any {
    return `${value}${this.language.fieldSuffix}`;
  }
}
